import axios, { AxiosResponse } from "axios"
import Settings from "./Settings"
import GetCurrentUser from "./GetCurrentUser"
import ClearUser from "./ClearUser"
import { Routes } from "../routes"

import { OptionsInterface } from "./API.interface"

let options: OptionsInterface = {
  headers: { "Content-Type": "application/json", accept: "text/plain" },

  crossdomain: true,
}

axios.interceptors.request.use(config => {
  // log a message before any HTTP request is sent
  console.log("The request ==== ", config)
  return config
})

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status
    const needsLogin = error?.response?.data?.needsLogin
    if ((status === 401 || needsLogin) && window.location.pathname !== Routes.SignIn.path) {
      ClearUser()
      window.location.href = Routes.SignIn.path
    }
    return Promise.reject(error)
  }
)
const API = {
  postAction: async (
    endpoint: string,
    params?: object,
    newOpts?: OptionsInterface
  ): Promise<AxiosResponse> => {
    let user = GetCurrentUser()
    if (user) {
      options = {
        headers: {
          "Content-Type": "application/json",
          accept: "text/plain",
          Authorization: "Bearer " + user,
        },

        crossdomain: true,
      }
    }
    return axios.post(
      endpoint.includes("http") ? endpoint : Settings.BasePathForAPI + endpoint,
      params ? params : null,
      newOpts ? newOpts : options
    )
  },
  getAction: async (
    endpoint: string,
    params?: string,
    newOpts?: OptionsInterface
  ): Promise<AxiosResponse> => {
    let user = GetCurrentUser()
    if (user) {
      options = {
        headers: {
          "Content-Type": "application/json",
          accept: "text/plain",
          Authorization: "Bearer " + user,
        },

        crossdomain: true,
      }
    }
    return axios.get(
      endpoint.includes("http")
        ? endpoint + (params ? "?" + params : "")
        : Settings.BasePathForAPI + endpoint + (params ? "?" + params : ""),
      newOpts ? newOpts : options
    )
  },

  postActionExternal: async (
    endpoint: string,
    params?: string,
    newOpts?: OptionsInterface
  ): Promise<AxiosResponse> =>
    axios.post(endpoint, params ? params : null, newOpts ? newOpts : options),
  getActionExternal: async (
    endpoint: string,
    params?: string,
    newOpts?: OptionsInterface
  ): Promise<AxiosResponse> => {
    let results = axios.get(endpoint, newOpts)

    return results
  },
}

export default API
